import { Component, Input } from '@angular/core';
import { IAutoCompleteData } from '../../interfaces/i-auto-complete-data';
import { IAuthor } from 'src/app/core/models/i-author';
import {
  FormArray,
  FormBuilder,
  FormControl,
  UntypedFormControl,
} from '@angular/forms';
import { AuthorService } from 'src/app/shared/services/author.service';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-authors',
  templateUrl: './authors.component.html',
  styleUrls: ['./authors.component.scss'],
})
export class AuthorsComponent {
  constructor(
    public formBuilder: FormBuilder,
    private authorService: AuthorService,
    private alertService: AlertService,
  ) {}

  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;
  @Input() selectedAuthors: FormArray<FormControl<IAuthor>>;
  @Input() searchedAuthor: FormControl;
  @Input() searchList: IAutoCompleteData[];
  @Input() authorList: IAuthor[];

  isSearchingAuthors = false;
  isSaving = false;

  handleAuthorSelected($event) {
    let selectedAuthor = this.authorList.filter((x) => x.id === $event.id);
    this.onAuthorSelected(selectedAuthor[0]);
  }

  updateSelectedAuthorLocation(updatedAuthor) {
    const index = this.selectedAuthors.controls.findIndex(
      (control) => control.value.id === updatedAuthor.id,
    );
    if (index !== -1) {
      const control = this.selectedAuthors.at(index) as FormControl;
      control.patchValue(updatedAuthor);
    }
  }

  onAuthorSelected(author: IAuthor): void {
    if (this.selectedAuthors.value.some((sa) => sa.id === author.id)) {
      this.alertService.warning(
        `You've already added the author ${author.name}, see below.`,
      );
      this.resetSearchedAuthorState();
      return;
    }

    this.addSelectedAuthor(author);
    this.resetSearchedAuthorState();
  }

  onRemoveAuthor(author: IAuthor): void {
    this.selectedAuthors.removeAt(
      this.selectedAuthors.value.findIndex((sa) => sa.id === author.id),
    );
  }

  refreshAuthor(author: IAuthor): void {
    this.authorService.getById$(author.id).subscribe((ra) => {
      if (author && author.id === ra.id) {
        let index = this.selectedAuthors.value.indexOf(author);
        if (index !== -1) {
          const control = this.selectedAuthors.at(index) as FormControl;
          control.patchValue(ra);
        }
      }
    });
  }

  public resetSearchedAuthorState(): void {
    this.searchList = [];
    this.searchedAuthor.setValue('');
    this.searchedAuthor.markAsPristine();
  }

  public addSelectedAuthor(author: IAuthor): void {
    this.selectedAuthors.push(this.formBuilder.control(author));
  }
}
